/* eslint-disable react/forbid-prop-types */
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Card,
  CardHeader,
  Row,
  Col,
  Button,
  Table,
  CardFooter
} from 'reactstrap';
import Datetime from 'react-datetime';

import {
  useDispatch, useSelector
} from 'react-redux';
import { SET_ACTIVE_ENTITY } from '../../../store/actions';
import usePersonas from '../../../hooks/usePersonas';

export default function CustomerPersonas() {
  const history = useHistory();

  const dispatch = useDispatch();
  const knowledge = useSelector((state) => (state.knowledge));

  console.log('Knowledge:', knowledge);

  const [endDate, setEndDate] = React.useState(new Date());
  const initEndDate = new Date(Date.now() - 30 * 24 * 3600000);
  const [startDate, setStartDate] = React.useState(initEndDate);
  const [showComparison, setShowComparison] = React.useState(false);

  usePersonas('default', startDate, endDate);

  const handleStartDateChange = useCallback((date) => {
    console.log('Start Date Changed:', date);
    setStartDate(date);
  }, []);

  const handleEndDateChange = useCallback((date) => {
    console.log('Start Date Changed:', date);
    setEndDate(date);
  }, []);

  const handleCompare = useCallback(() => {
    console.log('Comparing Dates:', startDate, endDate);
    setShowComparison(true);
  }, []);

  // Handle artwork selection
  const selectEntity = useCallback((entity) => {
    // Update local store
    dispatch({
      type: SET_ACTIVE_ENTITY,
      payload: entity
    });

    // Got to review page
    history.push(`/admin/personas/view/${entity.id}`);
  }, []);

  return (
    <Card className="m-0">
      <CardHeader className="border-0">
        <Row>
          <Col className="col-6">
            <h6 className="surtitle">Activity</h6>
            <h3 className="mb-0">Customer Personas</h3>
          </Col>
          <Col className="col-2">
            <span className="text-primary">Start Date</span>
            <Datetime
              dateFormat="MM/DD/YYYY"
              onChange={handleStartDateChange}
              timeFormat={false}
              value={startDate}
            />
          </Col>
          <Col className="col-2">
            <span className="text-primary">End Date</span>
            <Datetime
              dateFormat="MM/DD/YYYY"
              onChange={handleEndDateChange}
              timeFormat={false}
              value={endDate}
            />
          </Col>
          <Col className="col-2 position-relative">
            <Button
              className="bg-transparent border-primary text-dark position-absolute bottom-0"
              id="run"
              onClick={handleCompare}
            >
              Compare Dates
            </Button>
          </Col>
        </Row>
      </CardHeader>

      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th
              className="sort"
              data-sort="name"
              scope="col"
              style={{
                maxWidth: 200
              }}
            >
              <span>Name</span>
            </th>
            <th className="sort text-center" data-sort="matched" scope="col">
              <span>Customers</span>
            </th>
            <th className="sort text-center" data-sort="matched" scope="col">
              <span>Customers</span>
            </th>
            <th className="sort text-center" data-sort="value" scope="col">
              <span>Lifetime Value</span>
            </th>
            <th scope="col" />
          </tr>
        </thead>
        <tbody className="list">
          {knowledge.entities.map((entity, index) => (
            <tr key={index}>
              <th scope="row">
                <div className="col ml--2">
                  <h4 className="mb-0">
                    <a
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      {entity.name}
                    </a>
                  </h4>
                  {showComparison && (
                    <span style={{
                      marginLeft: '8px', fontSize: 'smaller', color: 'gray'
                    }}
                    >
                      Prev. Period
                    </span>
                  )}
                  <small />
                </div>
              </th>
              <td className="matched text-center">
                <div className="col ml--2">
                  <h4 className="mb-0">
                    <a
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      {entity.matched
                        ? entity.matched
                        : 0}
                    </a>
                  </h4>
                  {showComparison && (
                    <span style={{
                      marginLeft: '8px', fontSize: 'smaller', color: 'gray'
                    }}
                    >
                      999
                      <span style={{ color: 'red', marginLeft: '6px' }}>(↓10% )</span>
                    </span>
                  )}
                </div>
              </td>
              <td className="value text-center">
                <div className="col ml--2">
                  <h4 className="mb-0">
                    <a
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      {entity.value}
                    </a>
                  </h4>
                  {showComparison && (
                    <span style={{
                      marginLeft: '8px', fontSize: 'smaller', color: 'gray'
                    }}
                    >
                      $999
                      <span style={{ color: 'green', marginLeft: '6px' }}>(↑10% )</span>
                    </span>
                  )}
                </div>
              </td>
              <td className="text-right">
                <Button
                  color="primary"
                  size="md"
                  type="button"
                  onClick={() => {
                    // select entity
                    selectEntity(entity);
                  }}
                  style={{
                    width: 180
                  }}
                >
                  <span className="btn-inner--icon mr-3">
                    <i className="ni ni-badge" />
                  </span>
                  <span className="btn-inner--text">
                    View Profile
                  </span>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <CardFooter className="py-4" />
    </Card>
  );
}
